module.exports = __webpack_public_path__ + "1905aa77d7265596a9f41c84dffd9a40.MP3";